import React from "react";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  TableSortLabel,
  Paper,
  makeStyles,
} from "@material-ui/core";

import {
  DestinationUsageByEnvData,
  DestinationTableSortColumnName,
} from "../types";

const useStyles = makeStyles(() => ({
  scrollable: {
    overflowY: "auto",
    maxHeight: "500px",
  },
}));

export type DestinationTableSort = {
  column: DestinationTableSortColumnName;
  direction: "asc" | "desc";
};

export type DestinationTableProps = {
  destinations: DestinationUsageByEnvData[];
  sort: DestinationTableSort;
  onSort(column: DestinationTableSortColumnName): void;
};

export const DestinationTable = ({
  destinations,
  sort,
  onSort,
}: DestinationTableProps) => {
  const classes = useStyles();
  return (
    <Paper className={classes.scrollable}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={sort.column === "projName"}
                  direction={sort.direction}
                  onClick={() => onSort("projName")}
                >
                  <Typography variant="h6">Project</Typography>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={sort.column === "envName"}
                  direction={sort.direction}
                  onClick={() => onSort("envName")}
                >
                  <Typography variant="h6">Environment</Typography>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={sort.column === "destination"}
                  direction={sort.direction}
                  onClick={() => onSort("destination")}
                >
                  <Typography variant="h6">Destination</Typography>
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {destinations.map((d) => (
              <TableRow key={`${d.projID}-${d.envID}-${d.destination}`}>
                <TableCell scope="row">{d.projName}</TableCell>
                <TableCell scope="row">{d.envName}</TableCell>
                <TableCell scope="row">{d.destination}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
